import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=4a95c589&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=4a95c589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95c589",
  null
  
)

export default component.exports
import {QItem,QItemSection,QIcon,Ripple} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QIcon}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
